import { PushPlataforma } from '../../shared/interfaces/push.interface';

/** iPadOS se presenta como Mac: se distingue por la pantalla táctil. */
export function esIos(): boolean {
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
}

export function esAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

/** La app corre instalada (pantalla de inicio), no en una pestaña del navegador. */
export function esAppInstalada(): boolean {
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return iosStandalone || window.matchMedia('(display-mode: standalone)').matches;
}

/** Fuera de iOS todo usa el Web Push estándar, incluidos los navegadores de escritorio. */
export function plataformaPush(): PushPlataforma {
  return esIos() ? 'ios' : 'android';
}
